import React from 'react';
import './Backdrop.css'; // Assuming you have a CSS file for the backdrop styles

const Backdrop: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return <div className="backdrop" onClick={onClick}></div>;
}

export default Backdrop;